/* eslint-disable class-methods-use-this */
import {
  Module, VuexModule, getModule, Action, Mutation,
} from '@compassdigital/vuex-module-decorators';
import jwtDecode from 'jwt-decode';
import { DateTime } from 'luxon';
import store from '@/store';
import AppModule from '@/store/modules/app';
import UserModule from '@/store/modules/user';
import SystemModule from '@/store/modules/system';
import NotificationModule from '@/store/modules/notification';

let isHandlingDisabledUser = false;

@Module({
  dynamic: true,
  name: 'lifecycle',
  store,
})
class LifeCycleModule extends VuexModule {
  public initialized: boolean = false;

  @Mutation
  public setInitialized(val: boolean) {
    this.initialized = val;
  }

  @Action
  public async init() {
    this.setInitialized(true);
    if (!AppModule.accessToken) {
      throw new Error('no access token');
    }
    if (AppModule.accessToken) {
      const decode: { exp: number } = jwtDecode(AppModule.accessToken);
      const expiry = DateTime.fromSeconds(decode.exp);
      if (expiry > DateTime.local()) {
        await AppModule.authenticate();
        try {
          await Promise.all(
            [
              SystemModule.fetchMarkets(),
              SystemModule.fetchSectors(),
              SystemModule.fetchSettings(),
              NotificationModule.fetchNotifications(),
            ],
          );

          NotificationModule.startNotificationFetch();
        } catch (err) {
          console.log('could not load settings');
        }
      }
    }
  }

  @Action
  public async handleDisabledSession(): Promise<void> {
    if (isHandlingDisabledUser) {
      return;
    }

    isHandlingDisabledUser = true;

    try {
      const {
        DISABLED_USER_MESSAGE,
        redirectToLoginAfterDisabledUser,
      } = await import('@/util/AuthUtil');
      const { default: ToastModule } = await import('@/store/modules/toast');

      ToastModule.setToast({
        message: DISABLED_USER_MESSAGE,
        error: true,
        timeout: 5000,
      });

      await this.terminate();
      redirectToLoginAfterDisabledUser();
    } catch (err) {
      console.error('Failed to handle disabled session', err);
    } finally {
      isHandlingDisabledUser = false;
    }
  }

  @Action
  public async terminate(path?: string) {
    AppModule.logout();
    NotificationModule.stopNotificationFetch();
    NotificationModule.CLEAR_NOTIFICATIONS();
    this.setInitialized(false);
  }
}

export default getModule(LifeCycleModule);
